export default __webpack_public_path__ + "9c5dadf6e060a1789c9fd6f0d57b3166.png";